/* eslint-disable no-nested-ternary, react/no-did-mount-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withApollo, graphql } from 'react-apollo';
import compose from 'lodash/flowRight';

import SimpleErrorBoundary from 'Shared/ErrorBoundaries/Simple';

import { CATALOG_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import CoursePreview from 'Jsx/Shared/CoursePreview';
import GiftMembershipReminder from 'Shared/GiftMembershipReminder';

import { context } from 'Utils';
import MainMenu from 'Jsx/MainMenu/containers/';
import MainFooter from 'Jsx/MainFooter/containers';
import customLocalStorage from 'Jsx/Utils/customLocalStorage';

import FiltersV2 from 'Jsx/Catalog/components/FiltersV2';
import SearchLanding from 'Catalog/components/SearchLanding';
import { isFilterApplied } from 'Catalog/components/FiltersV2/redux/selectors';
import {
  toggleFilterDialog,
  clearAllFilters,
  showAllCourses,
} from 'Catalog/components/FiltersV2/redux/actions';
import OrderByV2 from 'Catalog/components/OrderByV2';
import FiltersMobile from 'Jsx/Catalog/components/FiltersV2/components/Mobile';

import { setDefaultOrderBy } from 'Catalog/components/OrderByV2/redux/actions';
import { grayMain } from 'crehana-ui/styles/colors';

import LandingV2 from '../components/LandingV2';
import ResultsV2 from '../components/ResultsV2';
import CoursesRecommendedForMe from '../components/CourseRecommended/CoursesRecommendedForMe';
import Slug from '../components/SEO/Slug';
import Breadcrumbs from '../components/SEO/Breadcrumbs';
import SliderHeaderV2 from '../components/SliderHeaderV2';
import getUserDiscount from '../graphql/getUserDiscount.graphql';

import NotificationDiscount from '../../HomeUser/sections/ui/NotificationDiscount/NotificationDiscount';

import FixedPremiumBar from 'Jsx/Shared/FixedPremiumBar';
import mixpanel from 'Jsx/Utils/mixpanelTracking';

const Container = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;
  display: flex;
  padding-bottom: ${props => (props.isOrganization ? '55' : '0')}px;

  @media (min-width: 768px) {
    margin: 0px auto 20px;
    ${props =>
      props.marginBottom &&
      `
      margin-bottom: ${props.marginBottom};
    `}
    width: calc(100% - 64px);
  }

  @media (min-width: 1140px) {
    margin-top: ${props => props.marginTop || '0px'};
  }

  @media (min-width: 1280px) {
    width: 1140px;
  }

  @media (min-width: 1440px) {
    width: 1280px;
  }

  @media (min-width: 1680px) {
    width: 1560px;
  }
`;

const Spacer = styled.div`
  background-color: #fff;
  position: relative;
  width: 100%;
  height: 0;
  transition: 0.3s;
  z-index: 10;

  @media (min-width: 1140px) {
    background: inherit;
    height: ${props => props.height || '32px'};
  }
`;

const FilterContainer = styled.div`
  position: relative;
  display: none;
  min-width: 232px;
  margin-right: 32px;
  @media (min-width: ${props => props.theme.media.laptop}) {
    display: flex;
    flex-direction: column;
    padding-top: 24px;
  }
  & * {
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
`;

const FilterButtonWrapper = styled.div`
  transition: margin-top 0.3s;
  z-index: 9;
  top: 0px;
  background-color: #fff;
  transition: 0.3s;
  margin: 0 auto;
  background-color: #fff;
  position: sticky;

  @media (min-width: 320px) {
    padding: 0;
    display: flex;
    align-items: center;
  }

  @media (min-width: 768px) {
    display: flex;
    padding: 16px;
    width: calc(100% - 64px);
    padding: 16px 0;
  }

  @media (min-width: ${props => props.theme.media.laptop}) {
    width: 1024px;
    display: none;
  }
`;

const SortByButton = styled.button`
  outline: none;
  /* width: 140px; */
  border: 1px solid ${grayMain};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  svg {
    margin-right: 8px;
  }
  @media (max-width: 414px) {
    border-right: unset;
  }
`;

class App extends Component {
  state = {
    mainMenuPosition: 'relative',
  };

  componentDidMount() {
    this.menuElement = document.querySelector('#MainMenuComponent');

    this.targetElement = document.querySelector('body');

    const jssStyles = document.getElementById('jss-server-sider');

    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }

    this.setState({
      mainMenuPosition: 'relative',
    });
  }

  getHeightMenu = () => {
    if (!this.menuElement) return 72;
    const { height } = this.menuElement.getBoundingClientRect();

    return height;
  };

  scrollTop = () => {
    if (typeof document !== 'undefined') {
      const scrollTop =
        document.querySelector('#scroll-to').offsetTop - this.getHeightMenu();

      if (window.scrollY > scrollTop) {
        window.scroll({ top: scrollTop, left: 0, behavior: 'smooth' });
      }
    }
  };

  removeCourseFromCart = id => {
    this.props.shoppingCart.removeCourseFromCart({ courseId: id });
  };

  ABTestCourseCart = (
    id,
    title,
    promoImage,
    professor,
    category,
    subcategory,
    prices,
    buyUrl,
    url,
    score,
    enrollments,
  ) => {
    /**
     * The second parameter is unnecessary but
     * maybe we will need that in the future :)
     */
    this.props.shoppingCart.addCourseToCart(
      {
        courseId: id,
      },
      {
        id,
        title,
        promoImage,
        professor,
        category,
        subcategory,
        prices,
        buyUrl,
        url,
        score,
        enrollments,
      },
    );
  };

  removePackFromCart = ({ id }) => {
    this.props.shoppingCart.removeBundleFromCart({ bundleId: id });
  };

  closeNotificationBox = () => {
    customLocalStorage.setItem('wasNotificationDiscountBoxShown', 'false');
  };

  showAllCourses = e => {
    e.preventDefault();
    const {
      clearAllFilters: clearAllFiltersAction,
      showAllCourses: showAllCoursesAction,
      setDefaultOrderBy: setDefaultOrderByAction,
    } = this.props;

    showAllCoursesAction();
    setDefaultOrderByAction();
    clearAllFiltersAction();
  };

  render() {
    const { mainMenuPosition } = this.state;
    const {
      user,
      search,
      isFilterApplied: filterApplied,
      allCourses,
      organization,
      countryPrefix,
      shoppingCart: { courseIdsInCart, bundleIdsInCart, loadingCart },
      categories,
      softwares,
      showRecommendedForMeCourses,
      userLanguage,
      t,
    } = this.props;

    const isOrganization = !!organization;
    const isPremiumMember = !!(user && user.isPremiumMember);
    const countryPrefixFormated =
      countryPrefix && countryPrefix.toLowerCase
        ? countryPrefix.toLowerCase()
        : '';

    const showCustomRecommended = showRecommendedForMeCourses;

    return (
      <div>
        <MainMenu
          mode="solid"
          position={mainMenuPosition}
          organization={organization}
          countryPrefix={countryPrefixFormated}
          categories={categories}
        />
        <GiftMembershipReminder />
        <div>
          {!isOrganization && !search && (
            <Container
              id="catalog-main-section"
              className="heroContainer"
              marginTop="48px"
              marginBottom="0px"
            >
              <SliderHeaderV2 />
            </Container>
          )}
          <Spacer
            id="scroll-to"
            height={search ? '72px' : isOrganization ? '100px' : null}
          />
          <Container marginBottom="0px">{!search && <Breadcrumbs />}</Container>
          {!search && !showCustomRecommended && (
            <FilterButtonWrapper>
              <SimpleErrorBoundary>
                <FiltersMobile />
              </SimpleErrorBoundary>
              <SortByButton>
                <OrderByV2 />
              </SortByButton>
            </FilterButtonWrapper>
          )}
          {search && !showCustomRecommended && (
            <SearchLanding
              userLanguage={userLanguage}
              search={search}
              scrollTop={this.scrollTop}
              courseIdsOwned={courseIdsInCart}
              packsIdsOwned={bundleIdsInCart}
              addCourseToCart={this.ABTestCourseCart}
              removeCourseFromCart={this.removeCourseFromCart}
              isOrganization={isOrganization}
              user={user}
              loadingCartButton={loadingCart}
            />
          )}
          <Container
            isOrganization={isOrganization}
            marginTop={search && '12px'}
            style={{ marginTop: 20 }}
          >
            {!search && !showCustomRecommended && (
              <FilterContainer id="filter__wrapper">
                <SimpleErrorBoundary>
                  <FiltersV2
                    isPremiumMember={isPremiumMember}
                    scrollTop={this.scrollTop}
                    options={context.getKey('order_by')}
                    countryPrefix={countryPrefixFormated}
                  />
                </SimpleErrorBoundary>
              </FilterContainer>
            )}
            {(allCourses || filterApplied) &&
              !search &&
              !showCustomRecommended && (
                <ResultsV2
                  userLanguage={userLanguage}
                  scrollTop={this.scrollTop}
                  courseIdsOwned={courseIdsInCart}
                  packsIdsOwned={bundleIdsInCart}
                  addCourseToCart={this.ABTestCourseCart}
                  removeCourseFromCart={this.removeCourseFromCart}
                  isOrganization={isOrganization}
                  user={user}
                  loadingCartButton={loadingCart}
                  showRecommendedForMeCourses={showRecommendedForMeCourses}
                  allCourses={allCourses}
                  search={search}
                  showCustomRecommended={showCustomRecommended}
                  cleanFiltersMsg={t('CLEAN_FILTERS')}
                />
              )}
            {showRecommendedForMeCourses && (
              <CoursesRecommendedForMe
                userLanguage={userLanguage}
                scrollTop={this.scrollTop}
                courseIdsOwned={courseIdsInCart}
                packsIdsOwned={bundleIdsInCart}
                addCourseToCart={this.ABTestCourseCart}
                removeCourseFromCart={this.removeCourseFromCart}
                isOrganization={isOrganization}
                user={user}
                loadingCartButton={loadingCart}
                showRecommendedForMeCourses={showRecommendedForMeCourses}
              />
            )}
            {!!this.props.discount &&
              !customLocalStorage.getItem(
                'wasNotificationDiscountBoxShown',
              ) && (
                <NotificationDiscount
                  open={
                    !customLocalStorage.getItem(
                      'wasNotificationDiscountBoxShown',
                    ) && !!this.props.discount
                  }
                  minimumAmount={this.props.minimumAmount}
                  currencyType="US$"
                  discount={this.props.discount}
                  closeNotificationBox={this.closeNotificationBox}
                  currentPage="/cursos-online/"
                  expiredDate={new Date(this.props.expiredDate).getTime()}
                />
              )}
            {!allCourses &&
              !filterApplied &&
              !search &&
              !showCustomRecommended && (
                <LandingV2
                  scrollTop={this.scrollTop}
                  courseIdsOwned={courseIdsInCart}
                  packsIdsOwned={bundleIdsInCart}
                  addCourseToCart={this.ABTestCourseCart}
                  removeCourseFromCart={this.removeCourseFromCart}
                  removePackFromCart={this.removePackFromCart}
                  isOrganization={isOrganization}
                  user={user}
                  loadingCartButton={loadingCart}
                  countryPrefix={countryPrefixFormated}
                  userLanguage={userLanguage}
                />
              )}
          </Container>
          <CoursePreview />
          {!isPremiumMember && !isOrganization && (
            <div className="hidden sm:block">
              <FixedPremiumBar
                domIds={['catalog-main-section']}
                message={t('BECOME_PREMIUM_DESCRIPTION', {
                  defaultValue: 'Accede a todos estos cursos con rebajas',
                })}
                onClick={() => {
                  mixpanel.track(
                    mixpanel.EVENTS.GO_TO,
                    {
                      origin: 'Catalog',
                      destination: 'Membership landing',
                    },
                    () => {
                      window.location.href = `${
                        countryPrefixFormated ? `/${countryPrefixFormated}` : ''
                      }/membresias/`;
                    },
                  );
                }}
                buttonLabel={t('BECOME_PREMIUM', {
                  defaultValue: 'Aprovecha',
                })}
              />
            </div>
          )}
          {!isOrganization && (
            <MainFooter
              countryPrefix={countryPrefixFormated}
              categories={categories}
              softwares={softwares}
            />
          )}
        </div>
        <Slug />
      </div>
    );
  }
}

App.defaultProps = {
  countryPrefix: '',
};

App.propTypes = {
  countryPrefix: PropTypes.string,
  isFilterApplied: PropTypes.bool,
  toggleFilterDialog: PropTypes.func.isRequired,
  search: PropTypes.string,
  user: PropTypes.shape({}),
  allCourses: PropTypes.bool.isRequired,

  clearAllFilters: PropTypes.func.isRequired,
  showAllCourses: PropTypes.func.isRequired,
  setDefaultOrderBy: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    name: PropTypes.string,
    originalId: PropTypes.number,
    logoThumbnail: PropTypes.string,
  }),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          slug: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
  softwares: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  showRecommendedForMeCourses: PropTypes.bool.isRequired,
  userLanguage: PropTypes.string.isRequired,
  // i18n
  t: PropTypes.func.isRequired,
};

App.defaultProps = {
  isFilterApplied: false,
  search: null,
  user: null,
  organization: null,
};

const mapStateToProps = state => ({
  isFilterApplied:
    isFilterApplied(state) || state.orderBy.itemSelected.slug !== 'online',
  allCourses: state.filters.allCourses,
  showRecommendedForMeCourses: state.filters.showRecommendedForMeCourses,
  search: state.search.value,
  user: state.user,
  userLanguage: state.userLanguage,
  organization: state.organization,
  countryPrefix: state.countryPrefix,
  categories: state.categories,
  softwares: state.softwares,
  tracks: state.tracks,
});

const mapDispatchToProps = {
  toggleFilterDialog,
  clearAllFilters,
  showAllCourses,
  setDefaultOrderBy,
};

const AppTranslation = withTranslation(CATALOG_TRANSLATION_KEY)(App);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withApollo,
  graphql(getUserDiscount, {
    name: 'response',
    props: ({ response }) => ({
      loading: response.loading,
      minimumAmount: response.userDiscount
        ? response.userDiscount.minimumAmount
        : 19,
      discount: response.userDiscount ? response.userDiscount.amount : 0,
      expiredDate: response.userDiscount
        ? response.userDiscount.expiredDate
        : '',
      error: response.error,
    }),
  }),
)(AppTranslation);
